import { useNavigate } from 'react-router-dom';
import { resolveImageUrl } from '../../../utils';

interface PromoImage {
  id: number;
  src: string;
  alt: string;
  title?: string;
  subtitle?: string;
  hasDownload?: boolean;
  hasVisitButton?: boolean;
  hasLinknetButton?: boolean;
  hasLeasingButton?: boolean;
  bgColor?: string;
  isClickable?: boolean;
  clickRoute?: string;
  clickUrl?: string;
}

interface PromoSliderSectionProps {
  horizontal?: boolean;
}

const PromoSliderSection = ({ horizontal = false }: PromoSliderSectionProps) => {
  const navigate = useNavigate();

  const promoImages: PromoImage[] = [
    {
      id: 1,
      src: resolveImageUrl("/images/icon (3).jpg"),
      alt: "September Deals 22% OFF",
    },
    {
      id: 2,
      src: resolveImageUrl("/images/wifi.png"),
      alt: "Mau Pasang Internet untuk Toko Anda?",
      title: "Mau Pasang Internet untuk Toko Anda?",
      hasLinknetButton: true,
      bgColor: "bg-[#1E2235]",
      isClickable: true,
      clickRoute: "/tenant-relation/linknet",
    },
    {
      id: 3,
      src: resolveImageUrl("/images/icon (11).png"),
      alt: "Mau Pasang Iklan di Music Mall?",
      title: "Mau Pasang Iklan di Music Mall?",
      hasVisitButton: true,
      bgColor: "bg-[#F25C3D]",
      isClickable: true,
      clickRoute: "/tenant-relation/playup",
    },
    {
      id: 4,
      src: resolveImageUrl("/images/gerobak.png"),
      alt: "Butuh Bikin Pameran di Area Mall?",
      title: "Butuh Bikin Pameran di Area Mall?",
      hasLeasingButton: true,
      bgColor: "bg-[#0D0D0D]",
      isClickable: true,
      clickUrl: "https://casualleasing.lippomalls.com/",
    },
  ];

  const handleImageClick = (image: PromoImage) => {
    if (!image.isClickable) return;
    if (image.clickUrl) {
      window.open(image.clickUrl, '_blank');
    } else if (image.clickRoute) {
      navigate(image.clickRoute);
    }
  };

  const renderCard = (image: PromoImage) => (
    <div
      key={image.id}
      onClick={() => handleImageClick(image)}
      className={`relative rounded-2xl overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02] shadow-sm ring-1 ring-gray-200 dark:ring-gray-700 ${horizontal ? 'h-[220px]' : 'flex-1 min-h-[160px]'
        }`}
    >
      {/* Background */}
      <div className={`absolute inset-0 ${image.bgColor || 'bg-black'}`}>
        <img
          src={image.src}
          alt={image.alt}
          className="w-full h-full object-cover"
          style={image.id === 1 ? { objectPosition: '50% 30%' } : {}}
        />
      </div>

      <div className="absolute inset-0 p-4 flex flex-col justify-between">
        <div className="text-white">
          {image.title && (
            <h3 className="text-base font-bold leading-snug drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
              {image.title}
            </h3>
          )}
        </div>

        <div className="flex flex-col items-center gap-2">
          {image.hasVisitButton && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigate('/tenant-relation/playup');
              }}
              className="bg-black hover:bg-gray-900 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-semibold transition-colors shadow-lg"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
              </svg>
              Visit PlayUp
            </button>
          )}

          {image.hasLinknetButton && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigate('/tenant-relation/linknet');
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-semibold transition-colors shadow-lg"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
              </svg>
              Daftar Linknet
            </button>
          )}

          {image.hasLeasingButton && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                window.open('https://casualleasing.lippomalls.com/', '_blank');
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-semibold transition-colors shadow-lg"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              Visit Casual Leasing
            </button>
          )}
        </div>
      </div>
    </div>
  );

  if (horizontal) {
    return (
      <>
        {promoImages.map((image) => renderCard(image))}
      </>
    );
  }

  return (
    <div className="h-full">
      <div className="flex flex-col gap-6 h-full">
        {promoImages.slice(0, 3).map((image) => renderCard(image))}
      </div>
    </div>
  );
};

export default PromoSliderSection;